import { render } from "./changepass.vue?vue&type=template&id=35969df3&scoped=true"
import script from "./changepass.vue?vue&type=script&lang=js"
export * from "./changepass.vue?vue&type=script&lang=js"

import "./changepass.vue?vue&type=style&index=0&id=35969df3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35969df3"]])

export default __exports__